import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, Play } from 'lucide-react';
// 4 video testimonial slots — leave empty for the client to upload later.
// To wire up a video, replace `videoSrc: null` with a URL string (mp4) and optionally update `poster`.
const videoTestimonials = [{
  id: 1,
  name: 'Testimonio 1',
  videoSrc: 'https://cdn.magicpatterns.com/uploads/iqr9UrvhL6crEMZ89Z5yWH/d_a_a_a_a_c_f_f_ce_videomp_.mp4',
  poster: null
}, {
  id: 2,
  name: 'Testimonio 2',
  videoSrc: 'https://cdn.magicpatterns.com/uploads/fpyzxVPVBkcRpHC3riUwYp/crea1.mov',
  poster: null
}, {
  id: 3,
  name: 'Testimonio 3',
  videoSrc: 'https://cdn.magicpatterns.com/uploads/2MfwTpZruwFmxsMPe2MniD/INFLuencer.mov',
  poster: null
}];
export function SocialProof() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const updateScrollState = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 5);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 5);
  };
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    updateScrollState();
    el.addEventListener('scroll', updateScrollState);
    window.addEventListener('resize', updateScrollState);
    return () => {
      el.removeEventListener('scroll', updateScrollState);
      window.removeEventListener('resize', updateScrollState);
    };
  }, []);
  const scrollByCard = (dir: 'left' | 'right') => {
    const el = scrollRef.current;
    if (!el) return;
    const card = el.querySelector<HTMLElement>('[data-card]');
    const cardWidth = card ? card.offsetWidth + 24 : 320;
    el.scrollBy({
      left: dir === 'left' ? -cardWidth : cardWidth,
      behavior: 'smooth'
    });
  };
  return <section className="py-20 bg-white px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-232">
      <div className="max-w-7xl mx-auto" data-id="element-233">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-234">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-4" data-id="element-235">
            Mujeres que ya dejaron de sentir que su premenstrual las domina
          </h2>
          <p className="text-gray-600 mt-3" data-id="element-236">
            Mirá lo que están contando en sus propios videos
          </p>
          <div className="w-24 h-1 bg-burgundy mx-auto mt-6" data-id="element-237"></div>
        </motion.div>

        <div className="relative" data-id="element-238">
          {/* Arrows */}
          <button onClick={() => scrollByCard('left')} disabled={!canScrollLeft} aria-label="Anterior" className={`hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 z-20 -translate-x-2 w-12 h-12 rounded-full bg-white border border-gray-200 shadow-lg items-center justify-center transition-all ${canScrollLeft ? 'hover:bg-burgundy hover:text-white hover:border-burgundy text-dark' : 'opacity-40 cursor-not-allowed text-gray-400'}`} data-id="element-239">
            <ChevronLeft className="w-6 h-6" data-id="element-240" />
          </button>
          <button onClick={() => scrollByCard('right')} disabled={!canScrollRight} aria-label="Siguiente" className={`hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 z-20 translate-x-2 w-12 h-12 rounded-full bg-white border border-gray-200 shadow-lg items-center justify-center transition-all ${canScrollRight ? 'hover:bg-burgundy hover:text-white hover:border-burgundy text-dark' : 'opacity-40 cursor-not-allowed text-gray-400'}`} data-id="element-241">
            <ChevronRight className="w-6 h-6" data-id="element-242" />
          </button>

          {/* Scroll container */}
          <div ref={scrollRef} className="flex gap-6 overflow-x-auto snap-x snap-mandatory scroll-smooth pb-6 -mx-4 px-4 md:mx-0 md:px-2" style={{
          scrollbarWidth: 'thin'
        }} data-id="element-243">
            {videoTestimonials.map((video, index) => <motion.div key={video.id} data-card initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="snap-start flex-shrink-0 w-[280px] sm:w-[320px] md:w-[340px]" data-id="element-244">
                <div className="relative aspect-[9/16] bg-gradient-to-br from-burgundy/90 to-burgundy-dark rounded-2xl overflow-hidden shadow-2xl border-2 border-gold/30 group" data-id="element-245">
                  {video.videoSrc ? <video src={video.videoSrc} poster={video.poster || undefined} controls playsInline className="w-full h-full object-cover" data-id="element-246" /> : <div className="w-full h-full flex flex-col items-center justify-center text-white/90 p-6 text-center" data-id="element-247">
                      <div className="w-20 h-20 rounded-full bg-white/15 border-2 border-white/40 flex items-center justify-center backdrop-blur-sm mb-5 group-hover:scale-110 transition-transform" data-id="element-248">
                        <Play className="w-8 h-8 fill-white text-white ml-1" data-id="element-249" />
                      </div>
                      <p className="font-serif text-2xl mb-2" data-id="element-250">{video.name}</p>
                      <p className="text-xs uppercase tracking-widest text-white/70" data-id="element-251">
                        Video próximamente
                      </p>
                    </div>}
                </div>
              </motion.div>)}
          </div>

          {/* Mobile hint */}
          <p className="md:hidden text-center text-xs text-gray-500 mt-2 italic" data-id="element-252">
            Deslizá → para ver más testimonios
          </p>
        </div>
      </div>
    </section>;
}